import { BrowserRouter as Router, Redirect, Route, Switch } from "react-router-dom";
import HomePage from "../pages/home/HomePage";
import ProjectsPage from "../pages/projects/ProjectsPage";
import ReligiousPhotosPage from "../pages/religious/ReligiousPhotosPage";
import ReligiousVideosPage from "../pages/religious/ReligiousVideosPage";
import ResumePage from "../pages/professional/ResumePage";
import CalendarPage from "../pages/religious/CalendarPage";
import FinancialRisk from "../apps/financial-risk/FinancialRisk";
import RandomGenerator from "../apps/maze-gen/random-generator";
import PujaListBuilder from "../apps/puja-list-gen/PujaListBuilder";
import BirthChartNamesPage from "../apps/birth-chart/BirthChartNamesPage";
import MerchPage from "../pages/merch/MerchPage";
import AppSupportPage from "../pages/support/AppSupportPage";
import AppPrivacyPage from "../pages/privacy/AppPrivacyPage";
import PanchangConsultationPage from "../pages/religious/PanchangConsultationPage";
import PanchangConsultationAdminPage from "../pages/religious/PanchangConsultationAdminPage";

function Routes() {
  return (
    <Router>
      <Switch>
        <Route path="/" exact component={HomePage} />
        <Route path="/home" exact component={HomePage} />
        <Route exact path="/professional" render={() => <Redirect to="/#professional" />} />
        <Route exact path="/professional/home" render={() => <Redirect to="/#professional" />} />
        <Route exact path="/professional/resume" component={ResumePage} />
        <Route exact path="/professional/projects" component={ProjectsPage} />
        <Route path="/professional/apps/financial-risk" component={FinancialRisk} />
        <Route path="/professional/apps/maze-generator" component={RandomGenerator} />
        <Route exact path="/religious" render={() => <Redirect to="/#religious" />} />
        <Route exact path="/religious/home" render={() => <Redirect to="/#religious" />} />
        <Route path="/religious/calendar" component={CalendarPage} />
        <Route path="/religious/videos" component={ReligiousVideosPage} />
        <Route path="/religious/photos" component={ReligiousPhotosPage} />
        <Route path="/religious/panchang-intake" component={PanchangConsultationPage} />
        <Route path="/religious/panchang-admin" component={PanchangConsultationAdminPage} />
        <Route path="/religious/apps/puja-list-builder" component={PujaListBuilder} />
        <Route path="/religious/apps/birth-chart-names" component={BirthChartNamesPage} />
        <Route exact path="/projects" render={() => <Redirect to="/professional/projects" />} />
        <Route exact path="/apps/financial-risk" render={() => <Redirect to="/professional/apps/financial-risk" />} />
        <Route exact path="/apps/maze-generator" render={() => <Redirect to="/professional/apps/maze-generator" />} />
        <Route exact path="/apps/puja-list-builder" render={() => <Redirect to="/religious/apps/puja-list-builder" />} />
        <Route exact path="/apps/birth-chart-names" render={() => <Redirect to="/religious/apps/birth-chart-names" />} />
        <Route path="/support" component={AppSupportPage} />
        <Route path="/privacy" component={AppPrivacyPage} />
        <Route path="/merch" component={MerchPage} />
      </Switch>
    </Router>
  );
}

export default Routes;
